import Link from 'next/link';

export const AdviserFooter = ({ footerLinks }) => (
  footerLinks.map((section) => (
    <div key={section.title} className="col-span-1 mt-10">
      <h3 className="mb-4 footer-accordion-title">
        <a href={section.href} className="hover:underline">{section.title}</a>
      </h3>
      <ul className="space-y-3">
        {section.links.map((link) => (
          <li key={link.text}>
            {link.external ? (
              <a
                href={link.href}
                className="footer-accordion-content hover:underline"
                rel="nofollow"
              >
                {link.text}
              </a>
            ) : (
              <Link
                href={link.href}
                className="footer-accordion-content hover:underline"
              >
                {link.text}
              </Link>
            )}
          </li>
        ))}
        {section.socialLinks && (
          <li className="flex items-center gap-4 mt-4">
            {section.socialLinks.map((link) => (
              <Link href={link.href} key={link.icon}>
                <img
                  src={`/img/icons/${link.icon}.svg`}
                  alt={link.icon}
                  className="w-6 h-6"
                />
              </Link>
            ))}
          </li>
        )}
      </ul>
    </div>
  ))
);
